import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { SubmitDealStepProps } from '@/types/submit-deal.types';

export const StepSwot = ({ formData, updateFormData, errors, clearError, t }: SubmitDealStepProps) => {
  const handleChange = (field: string, value: string) => {
    updateFormData('swot', { [field]: value });
    clearError(field);
  };

  return (
    <div className="space-y-6">
      <div className="bg-muted/50 p-4 rounded-lg">
        <p className="text-sm text-muted-foreground">{t.step10.sectionHint}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="strengths">{t.step10.strengths} *</Label>
          <Textarea
            id="strengths"
            value={formData.swot.strengths}
            onChange={(e) => handleChange('strengths', e.target.value)}
            placeholder={t.step10.strengthsPlaceholder}
            rows={5}
            className={errors.strengths ? 'border-destructive' : ''}
          />
          <p className={`text-xs ${formData.swot.strengths.length >= 10 ? 'text-green-600' : 'text-muted-foreground'}`}>
            {formData.swot.strengths.length} characters
          </p>
          {errors.strengths && <p className="text-sm text-destructive">{errors.strengths}</p>}
        </div>

        <div className="space-y-2">
          <Label htmlFor="weaknesses">{t.step10.weaknesses} *</Label>
          <Textarea
            id="weaknesses"
            value={formData.swot.weaknesses}
            onChange={(e) => handleChange('weaknesses', e.target.value)}
            placeholder={t.step10.weaknessesPlaceholder}
            rows={5}
            className={errors.weaknesses ? 'border-destructive' : ''}
          />
          <p className={`text-xs ${formData.swot.weaknesses.length >= 10 ? 'text-green-600' : 'text-muted-foreground'}`}>
            {formData.swot.weaknesses.length} characters
          </p>
          {errors.weaknesses && <p className="text-sm text-destructive">{errors.weaknesses}</p>}
        </div>

        <div className="space-y-2">
          <Label htmlFor="opportunities">{t.step10.opportunities} *</Label>
          <Textarea
            id="opportunities"
            value={formData.swot.opportunities}
            onChange={(e) => handleChange('opportunities', e.target.value)}
            placeholder={t.step10.opportunitiesPlaceholder}
            rows={5}
            className={errors.opportunities ? 'border-destructive' : ''}
          />
          <p className={`text-xs ${formData.swot.opportunities.length >= 10 ? 'text-green-600' : 'text-muted-foreground'}`}>
            {formData.swot.opportunities.length} characters
          </p>
          {errors.opportunities && <p className="text-sm text-destructive">{errors.opportunities}</p>}
        </div>

        <div className="space-y-2">
          <Label htmlFor="threats">{t.step10.threats} *</Label>
          <Textarea
            id="threats"
            value={formData.swot.threats}
            onChange={(e) => handleChange('threats', e.target.value)}
            placeholder={t.step10.threatsPlaceholder}
            rows={5}
            className={errors.threats ? 'border-destructive' : ''}
          />
          <p className={`text-xs ${formData.swot.threats.length >= 10 ? 'text-green-600' : 'text-muted-foreground'}`}>
            {formData.swot.threats.length} characters
          </p>
          {errors.threats && <p className="text-sm text-destructive">{errors.threats}</p>}
        </div>
      </div>
    </div>
  );
};
